import { Badge } from "@chakra-ui/react";
import { CommandType } from "../types/command.types";

const CommandTypeBadge = ({ type }: { type: CommandType }) => {
	if (type === CommandType.POSTE) {
		return (
			<Badge
				width={"fit-content"}
				textAlign={"center"}
				lineHeight="30px"
				fontSize="14px"
				height={"30px"}
				px="8px"
				rounded={"xl"}
				backgroundColor="yellow.50"
				color="yellow.700"
				border={"solid 1px"}
				borderColor="yellow.200"
				textTransform="none"
			>
				Physique
			</Badge>
		);
	}
	if (type === CommandType.OTOSCAN) {
		return (
			<Badge
				width={"fit-content"}
				textAlign={"center"}
				height={"30px"}
				lineHeight="30px"
				fontSize="14px"
				rounded={"xl"}
				px="8px"
				backgroundColor="purple.50"
				color="purple.700"
				border={"solid 1px"}
				borderColor="purple.200"
				textTransform="none"
			>
				Otoscan
			</Badge>
		);
	}
	if (type === CommandType.THREED) {
		return (
			<Badge
				width={"fit-content"}
				textAlign={"center"}
				height={"30px"}
				lineHeight="30px"
				fontSize="14px"
				rounded={"xl"}
				px="8px"
				backgroundColor="brand.50"
				color="brand.700"
				border={"solid 1px"}
				borderColor="brand.200"
				textTransform="none"
			>
				3D
			</Badge>
		);
	}
	if (type === CommandType.SUPPLY) {
		return (
			<Badge
				width={"fit-content"}
				textAlign={"center"}
				lineHeight="30px"
				height={"30px"}
				fontSize="14px"
				rounded={"xl"}
				px="8px"
				backgroundColor="pink.50"
				color="pink.700"
				border={"solid 1px"}
				borderColor="pink.200"
				textTransform="none"
			>
				Fournitures
			</Badge>
		);
	}
	if (type === CommandType.REWORK) {
		return (
			<Badge
				width={"fit-content"}
				textAlign={"center"}
				lineHeight="30px"
				height={"30px"}
				fontSize="14px"
				rounded={"xl"}
				px="8px"
				backgroundColor="#F3FEE7"
				color="#3B7C0F"
				border={"solid 1px"}
				borderColor="#D0F8AB"
				textTransform="none"
			>
				Refonte
			</Badge>
		);
	}
	return <>{type}</>;
};

export default CommandTypeBadge;
